<template>
  <div class="product_box lits_product_box flex-c-c-c" @click="jumpDetail">
    <div class="pro_info flex-r-s-c">
      <van-image width="2.56rem" height="1.92rem" :src="myinfo.iconUrl" />
      <div class="list_pro_info">
        <div class="pro_name van-multi-ellipsis--l2">{{ myinfo.name }}</div>
        <div class="pro_brand_model van-ellipsis">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom flex-r-sb-c">
          <div class="pro_money">￥<span
            style="font-size: 0.49rem;"
          >{{ myinfo.showPrice === 0? myinfo.price :'详询客服' }}</span></div>
          <div class="pro_btn">
            <van-icon name="cart" @click.stop="toCart(myinfo)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shoppingCart_addUnion } from '@/api/cart'
export default {
  props: {
    info: { type: Object, default: () => { } }
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {

    // 加入购物车
    toCart(item) {
      const parms = { productId: item.productId, priceNum: item.minQuantity }
      console.log(parms)
      shoppingCart_addUnion(parms).then(res => {
        this.$toast({ message: '加入成功！', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
      })
    },
    // 进入详情
    jumpDetail() {
      sessionStorage.setItem('classify_pro_id', 'classfily' + this.id)
      sessionStorage.setItem('jump', true)
      this.$router.push('/product/detail?productId=' + this.myinfo.productId)
    }
  }
}
</script>
